<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">Client Consent</h3>
      </v-card-title>
      <v-card-text>

        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>

              <v-flex xs12 md6>
                <v-text-field :label="labels.customName" v-model="reportForm.customName" data-vv-name="customName" :data-vv-as="labels.customName"></v-text-field>
              </v-flex>

              <v-flex xs12 md6></v-flex>

              <v-flex xs12 md6>
                <v-autocomplete :items="promotionList" v-model="reportForm.promotion" :label="labels.promotion" item-text="label" item-value="value" data-vv-name="promotion" :data-vv-as="labels.promotion" :error-messages="errors.collect('promotion')" clearable></v-autocomplete>
              </v-flex>

              <v-flex xs12 md6></v-flex>

              <v-flex xs12 md6>
                <v-autocomplete :items="latestProductList" v-model="reportForm.latestProduct" :label="labels.latestProduct" item-text="label" item-value="value" data-vv-name="latestProduct" :data-vv-as="labels.latestProduct" :error-messages="errors.collect('latestProduct')" clearable></v-autocomplete>
              </v-flex>

              <v-flex xs12 md6></v-flex>

              <v-flex xs12 md6>
                <v-autocomplete :items="hardcopyMailList" v-model="reportForm.hardcopyMail" :label="labels.hardcopyMail" item-text="label" item-value="value" data-vv-name="hardcopyMail" :data-vv-as="labels.hardcopyMail" :error-messages="errors.collect('hardcopyMail')" clearable></v-autocomplete>
              </v-flex>

              <v-flex xs12 md6></v-flex>

              <v-flex xs12 md6>
                <v-autocomplete :items="memberList" v-model="reportForm.member" :label="labels.member" item-text="label" item-value="value" data-vv-name="member" :data-vv-as="labels.member" :error-messages="errors.collect('member')" clearable></v-autocomplete>
              </v-flex>

              <v-flex xs12 class="pt-3">
                <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{labels.export}}
                </v-btn>

                <v-btn-toggle mandatory v-model="reportForm.format">
                  <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{format.label}}</span>
                    <v-icon :color="format.color">{{format.icon}}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>

            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      labels: {
        customName: 'Report Name',
        promotion: 'Promotion Email/SMS',
        latestProduct: 'Latest Product Email/SMS',
        hardcopyMail: 'Hardcopy Mail',
        member: 'Member',
        format: 'Export Format',
        export: 'Export to'
      },
      reportForm: {
        customName: undefined,
        promotion: undefined,
        latestProduct: undefined,
        hardcopyMail: undefined,
        member: undefined,
        format: undefined
      },
      menu: {},
      promotionList: [],
      latestProductList: [],
      hardcopyMailList: [],
      memberList: [],
      supportedFormat: [],
      submitting: false
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        const apiURI = this.$store.state.reports.agencyReports.menu.travelClientConsent
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.promotionList = data.promotionList
            this.latestProductList = data.latestProductList
            this.hardcopyMailList = data.hardcopyMailList
            this.memberList = data.memberList
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
